import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'eventType',
})
export class EventTypePipe implements PipeTransform {
  transform(calendarType: string): string {
    if (!calendarType) return '';
    const trimmed = calendarType.trim();
    const lower = trimmed.toLowerCase();
    return lower === 'personal event type' ? 'Personal' : lower === 'team event type' ? 'Team' : trimmed;
  }
}
